import { SidebarItemProps } from "./types";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { classNames, useTranslate } from "helpers/common";
import { SidebarChildItem } from "../SidebarChildItem";
import { useState } from "react";

const MenuItem: React.FC<SidebarItemProps> = (props) => {
  const { text, icon, route, childItems, openSidebar, position = "top" } = props;

  const { t } = useTranslate();

  const [childItemsVisible, setChildItemsVisible] = useState<boolean>(false);
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const handleChildItemsVisible = () => {
    setChildItemsVisible(!childItemsVisible);
  };

  // Prazan popis podstavki nije isto što i njihov izostanak: bez ove provjere stavka bez djece
  // dobiva strelicu za otvaranje i prazan izbornik na hover.
  const hasChildItems = !!childItems?.length;

  return (
    <>
      <div
        className="relative"
        onMouseEnter={() => !openSidebar && hasChildItems && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <NavLink
          end
          to={route}
          className={({ isActive }) =>
            classNames(
              isActive ? "text-[#f6fafb] active" : "text-[#888a97] ",
              "group rounded-md text-sm font-medium h-12 flex items-center peer"
            )
          }
        >
          <div className="flex justify-start items-center">
            <div className="pl-5 pr-3">
              <ReactSVG
                src={icon}
                className="w-6 h-6 transition-colors text-[#888a97] stroke-[#888a97] group-[.active]:text-[#f6fafb] group-[.active]:stroke-[#f6fafb] group-hover:text-[#f6fafb] group-hover:stroke-[#f6fafb] "
              />
            </div>
            <div
              className={classNames(
                openSidebar ? "" : "hidden",
                "transition-colors duration-200 ease-out hover:text-[#edeef8] group-hover:text-[#edeef8] "
              )}
            >
              {t(text)}
            </div>
          </div>
        </NavLink>
        <div
          className={classNames(
            openSidebar && hasChildItems
              ? "peer-[.active]:block transition"
              : "hidden",
            " overflow-hidden pl-12"
          )}
        >
          <span
            className="absolute right-4 top-4 cursor-pointer"
            onClick={handleChildItemsVisible}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className={classNames(
                childItemsVisible ? "rotate-[-180deg]" : "",
                "h-5 w-5 transition-transform duration-200 stroke-[#888a97] "
              )}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 8.25l-7.5 7.5-7.5-7.5"
              />
            </svg>
          </span>
          <ul
            className={classNames(
              childItemsVisible ? "opacity-100 h-auto" : "opacity-0 h-0",
              "relative transition-all ease-in-out duration-500 "
            )}
          >
            {childItems &&
              childItems.map((item, index) => {
                return (
                  <SidebarChildItem
                    key={index}
                    text={item.text}
                    icon={item.icon}
                    iconColor={item.iconColor}
                    route={item.route}
                    count={item.count}
                  />
                );
              })}
          </ul>
        </div>

        {/* Flyout menu for collapsed sidebar */}
        {!openSidebar && hasChildItems && isHovered && (
          <div
            className={classNames(
              position === "bottom" ? "bottom-0" : "top-0",
              "absolute left-full z-50 flex"
            )}
          >
            {/* Invisible bridge to maintain hover */}
            <div className="w-2 h-12" />
            <div className="relative min-w-48 bg-[#161719] rounded-md shadow-xl py-2">
              {/* Arrow pointer */}
              <div
                className={classNames(
                  position === "bottom" ? "bottom-4" : "top-4",
                  "absolute -left-2 w-0 h-0 border-y-8 border-y-transparent border-r-8 border-r-[#161719] "
                )}
              />
             
              {childItems && (
                <ul className="px-3 min-w-[200px]">
                  {childItems.map((item, index) => (
                    <SidebarChildItem
                      key={index}
                      text={item.text}
                      icon={item.icon}
                      iconColor={item.iconColor}
                      route={item.route}
                      count={item.count}
                      isParentHovered={true}
                    />
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default MenuItem;
